module.exports = __webpack_public_path__ + "static/media/settings-icon-active.003a03f9.svg";